<div class="agents-page__main">
  <div class="agents-page__title">
    <div class="agents-page-title vox-heading-3" translate>agents.title</div>
    <button (click)="addAgent()" class="vox-btn vox-btn-secondary" translate>agents.actions.create</button>
  </div>
  <vov-agents-table (onDeleteAgent)="deleteAgent($event)" (onEditAgent)="editAgent($event)"></vov-agents-table>
</div>
